import React from 'react';
import LandingPanel from '../../landingPagePanel/landingPagePanel';
import {ToastContainer} from "react-toastify";
import LandingSidebar from '../../landingSidebar/landingSidebar';

const stormSidebarLinks = [
    {label: 'Overview', to: '/distributed-computing/storm'},
];

const stormConcepts = [
    {id: 1, title: 'What is Apache Storm?',
        content: 'An introduction to Apache Storm and real-time stream processing.',
        slug: 'what-is-apache-storm',
        image: '/images/distributed/storm-landing/what-is-apache-storm.svg',
        enabled: false,
        sourceLinks: []},
    {id: 2, title: 'Concepts in Storm',
        content: 'The concepts behind Apache Storm',
        slug: 'storm-concepts',
        image: '/images/distributed/distributed-framework-landing/concepts.svg',
        enabled: false,
        sourceLinks: []},
    {id: 3, title: 'Topologies',
        content: 'The directed graph of spouts and bolts that defines a Storm job',
        slug: 'storm-topologies',
        image: '/images/distributed/storm-landing/topologies.svg',
        enabled: false,
        sourceLinks: []},
    {id: 4, title: 'Spouts',
        content: 'The source of a stream of tuples entering a topology',
        slug: 'storm-spouts',
        image: '/images/distributed/storm-landing/spouts.svg',
        enabled: false,
        sourceLinks: []},
    {id: 5, title: 'Bolts',
        content: 'The units that process, filter, and transform tuples',
        slug: 'storm-bolts',
        image: '/images/distributed/storm-landing/bolts.svg',
        enabled: false,
        sourceLinks: []},
    {id: 6, title: 'Stream Groupings',
        content: 'How tuples are routed from one bolt to the next',
        slug: 'storm-stream-groupings',
        image: '/images/distributed/storm-landing/stream-groupings.svg',
        enabled: false,
        sourceLinks: []},
    {id: 7, title: 'Reliability and Acking',
        content: 'How Storm guarantees a tuple is fully processed',
        slug: 'storm-reliability-acking',
        image: '/images/distributed/storm-landing/reliability-acking.svg',
        enabled: false,
        sourceLinks: []},
    {id: 8, title: 'Parallelism and Scheduling',
        content: 'Running many executors of a bolt side by side',
        slug: 'storm-parallelism-scheduling',
        image: '/images/distributed/storm-landing/parallelism-scheduling.svg',
        enabled: false,
        sourceLinks: []},
    {id: 9, title: 'Nimbus and Supervisors',
        content: 'The master and worker nodes that run a Storm cluster',
        slug: 'storm-nimbus-supervisors',
        image: '/images/distributed/storm-landing/nimbus-supervisors.svg',
        enabled: false,
        sourceLinks: []},
    {id: 10, title: 'Storm UI',
        content: 'Monitoring topologies, workers, and throughput',
        slug: 'storm-ui',
        image: '/images/distributed/storm-landing/storm-ui.svg',
        enabled: false,
        sourceLinks: []},
    {id: 11, title: 'Observability in Storm',
        content: 'Storm metrics with Prometheus and Grafana',
        slug: 'storm-observability',
        image: '/images/distributed/storm-landing/observability.svg',
        enabled: false,
        sourceLinks: []},
    {id: 12, title: 'Unit Testing in Storm',
        content: 'How to unit test spouts and bolts',
        slug: 'storm-unit-testing',
        image: '/images/distributed/storm-landing/unit-testing.svg',
        enabled: false,
        sourceLinks: []}
];

const stormTopologyDetails = [
    {id: 1, title: 'Tuple Anatomy',
        content: 'The named, ordered values that make up a tuple',
        slug: 'storm-tuple-anatomy',
        image: '/images/distributed/storm-landing/tuple-anatomy.svg',
        enabled: false,
        sourceLinks: []},
    {id: 2, title: 'Bolt Lifecycle',
        content: 'Prepare, execute, and cleanup for a bolt',
        slug: 'storm-bolt-lifecycle',
        image: '/images/distributed/storm-landing/bolt-lifecycle.svg',
        enabled: false,
        sourceLinks: []},
    {id: 3, title: 'Task and Executor Assignment',
        content: 'How Storm distributes tasks across executors',
        slug: 'storm-task-executor-assignment',
        image: '/images/distributed/storm-landing/task-executor-assignment.svg',
        enabled: false,
        sourceLinks: []},
    {id: 4, title: 'Stateful and Stateless Bolts',
        content: 'Bolts that carry data between tuples, and bolts that do not',
        slug: 'storm-stateful-stateless-bolts',
        image: '/images/distributed/storm-landing/stateful-stateless-bolts.svg',
        enabled: false,
        sourceLinks: []},
    {id: 5, title: 'Windowing',
        content: 'Aggregating tuples over a sliding or tumbling window of time',
        slug: 'storm-windowing',
        image: '/images/distributed/storm-landing/windowing.svg',
        enabled: false,
        sourceLinks: []},
    {id: 6, title: 'Trident',
        content: "Storm's higher-level API for exactly-once processing",
        slug: 'storm-trident',
        image: '/images/distributed/storm-landing/trident.svg',
        enabled: false,
        sourceLinks: []},
    {id: 7, title: 'Backpressure',
        content: 'Slowing a spout down when downstream bolts fall behind',
        slug: 'storm-backpressure',
        image: '/images/distributed/storm-landing/backpressure.svg',
        enabled: false,
        sourceLinks: []}
];

const stormSimpleExamples = [
    {id: 1, title: 'Hello Topology',
        content: 'The simplest spout-and-bolt topology, logging every tuple it receives',
        slug: 'storm-hello-topology',
        image: '/images/distributed/storm-landing/hello-topology.svg',
        enabled: false,
        sourceLinks: []},
    {id: 2, title: 'Word Count Topology',
        content: 'The classic streaming word count example',
        slug: 'storm-word-count-topology',
        image: '/images/distributed/storm-landing/word-count-topology.svg',
        enabled: false,
        sourceLinks: []},
    {id: 3, title: 'Rolling Window Count',
        content: 'Counting events over a sliding time window',
        slug: 'storm-rolling-window-count',
        image: '/images/distributed/storm-landing/rolling-window-count.svg',
        enabled: false,
        sourceLinks: []},
    {id: 4, title: 'Filter and Route Bolt',
        content: 'A bolt that filters tuples and routes them to different downstream bolts',
        slug: 'storm-filter-route-bolt',
        image: '/images/distributed/storm-landing/filter-route-bolt.svg',
        enabled: false,
        sourceLinks: []}
];

const stormAdvancedExamples = [
    {id: 1, title: 'Real-Time Trending Topics',
        content: 'Detecting trending hashtags from a live stream of posts',
        slug: 'storm-trending-topics',
        image: '/images/distributed/storm-landing/trending-topics.svg',
        enabled: false,
        sourceLinks: []},
    {id: 2, title: 'Fraud Detection Topology',
        content: 'Joining transaction streams to flag suspicious activity in real time',
        slug: 'storm-fraud-detection-topology',
        image: '/images/distributed/storm-landing/fraud-detection-topology.svg',
        enabled: false,
        sourceLinks: []}
];

const StormLanding = () => {
    return (
        <React.Fragment>
            <ToastContainer
                autoClose={5000}
                hideProgressBar={true}
            />
            <div className="relative space-y-4 flex flex-col md:grid md:space-y-0 w-full md:grid-cols-12 2xl:grid-cols-12 md:flex-1 md:grid-rows-full">
                <LandingSidebar title="Apache Storm" links={stormSidebarLinks}/>
                <section className="pt-2 border-gray-200 md:col-span-10 lg:col-span-10 2xl:col-span-10 pb-24">
            <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                <div className="w-full px-4 grid lg:grid-cols-3 gap-x-6 gap-y-12 lg:gap-y-0">
                    <div className="lg:pr-12 lg:place-self-top">
                        <div className="flex flex-col ">
                            <svg className="text-red-400 text-2xl" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                                <path d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8" stroke="#222222"  strokeWidth="1.2" opacity="0.5"/>
                            </svg>
                            <div className="h-2" />
                            <div className="flex  rounded-lg">
                                <div>
                                    <h2 className="text-2xl font-semibold
											leading-tight text-gray-800 false">Storm Concepts
                                    </h2></div>
                            </div>
                            <div className="h-6" />
                            <p className="leading-snug text-gray-500">Some of the concepts and functionality underpinning Apache Storm
                            </p>
                            <div className="h-6" />
                        </div>
                    </div>
                    <div className="lg:col-span-2 grid lg:grid-cols-2 gap-4">
                        {stormConcepts.map((data) => (
                            <LandingPanel key={data.id} title={data.title} imageSource={data.image} to={"/distributed-computing/storm/concepts/" + data.slug} strapLine={data.content} enabled={data.enabled}  />
                        ))}
                    </div>
                </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                <div className="w-full px-4 grid lg:grid-cols-3 gap-x-6 gap-y-12 lg:gap-y-0">
                    <div className="lg:pr-12 lg:place-self-top">
                        <div className="flex flex-col ">
                            <svg className="text-blue-400 text-2xl" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                                <path d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8" stroke="#222222"  strokeWidth="1.2" opacity="0.5"/>
                            </svg>
                            <div className="h-2"></div>
                            <div className="flex  rounded-lg">
                                <div>
                                    <h2 className="text-2xl font-semibold
											leading-tight text-gray-800 false">Topology Features
                                    </h2></div>
                            </div>
                            <div className="h-6"></div>
                            <p className="leading-snug text-gray-500">Some features we find in Topologies
                            </p>
                            <div className="h-6"></div>
                        </div>
                    </div>
                    <div className="lg:col-span-2 grid lg:grid-cols-2 gap-4">
                        {stormTopologyDetails.map((data) => (
                            <LandingPanel key={data.id}  title={data.title} imageSource={data.image} to={"/distributed-computing/storm/topologies/" + data.slug} strapLine={data.content} enabled={data.enabled}  />
                        ))}
                    </div>
                </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                <div className="w-full px-4 grid lg:grid-cols-3 gap-x-6 gap-y-12 lg:gap-y-0">
                    <div className="lg:pr-12 lg:place-self-top">
                        <div className="flex flex-col ">
                            <svg className="text-green-400 text-2xl" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                                <path d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8" stroke="#222222"  strokeWidth="1.2" opacity="0.5"/>
                            </svg>
                            <div className="h-2"></div>
                            <div className="flex  rounded-lg">
                                <div>
                                    <h2 className="text-2xl font-semibold
											leading-tight text-gray-800 false">Simple Examples
                                    </h2></div>
                            </div>
                            <div className="h-6"></div>
                            <p className="leading-snug text-gray-500">Some simple examples with Apache Storm
                            </p>
                            <div className="h-6"></div>
                        </div>
                    </div>
                    <div className="lg:col-span-2 grid lg:grid-cols-2 gap-4">
                        {stormSimpleExamples.map((data) => (
                            <LandingPanel key={data.id}  title={data.title} imageSource={data.image} to={"/distributed-computing/storm/examples/" + data.slug} strapLine={data.content} enabled={data.enabled}  />
                        ))}
                    </div>
                </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                <div className="w-full px-4 grid lg:grid-cols-3 gap-x-6 gap-y-12 lg:gap-y-0">
                    <div className="lg:pr-12 lg:place-self-top">
                        <div className="flex flex-col ">
                            <svg className="text-fuchsia-800 text-2xl" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                                <path d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8" stroke="#222222"  strokeWidth="1.2" opacity="0.5"/>
                            </svg>
                            <div className="h-2"></div>
                            <div className="flex  rounded-lg">
                                <div>
                                    <h2 className="text-2xl font-semibold
											leading-tight text-gray-800 false">Advanced Examples
                                    </h2></div>
                            </div>
                            <div className="h-6"></div>
                            <p className="leading-snug text-gray-500">Some more in depth examples
                            </p>
                            <div className="h-6"></div>
                        </div>
                    </div>
                    <div className="lg:col-span-2 grid lg:grid-cols-2 gap-4">
                        {stormAdvancedExamples.map((data) => (
                            <LandingPanel key={data.id}  title={data.title} imageSource={data.image} to={"/distributed-computing/storm/examples/" + data.slug} strapLine={data.content} enabled={data.enabled}  />
                        ))}
                    </div>
                </div>
            </div>
                </section>
            </div>

        </React.Fragment>
    )
};

export default React.memo(StormLanding);
